import React from "react";
import HomeBanner from '../components/homeBanner/homeBanner';
import KtempleNav from '../components/ktempleNav/ktempleNav';
import Kirtan from "../components/kirtan/kirtan";
import Footer from '../components/Footer/Footer';
import VisitingTemple from '../components/VisitingTemple/VisitingTemple';
import DocumentMeta from 'react-document-meta';

function KirtanPage() {
const meta = {
    title: "Krishna Temple Kirtan - Radha Madhav Krishna Temple Milwaukee",
    description: "Join us for Kirtan at the Radha Madhav Krishna Temple in Milwaukee. Experience the joy of devotional singing and community spirit.",
    keywords: "Kirtan, Radha Madhav Krishna Temple, Milwaukee, devotional singing, community events"
  };
  return (
    <div>
      <DocumentMeta {...meta} />
      <KtempleNav />
      <HomeBanner />
      <Kirtan />
      <VisitingTemple />
      <Footer />
    </div>
  )
}

export default KirtanPage